import { render } from "./StayDetails.vue?vue&type=template&id=2bf6bdb8"
import script from "./StayDetails.vue?vue&type=script&lang=js"
export * from "./StayDetails.vue?vue&type=script&lang=js"

import "@/shared/css/details.css?vue&type=style&index=0&lang=css&external"
import "./StayDetails.vue?vue&type=style&index=1&id=2bf6bdb8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__